import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
    className?: any,
    color?: any,
    children: ReactNode | string,
}

const ErrorText = (props: Props) => {
    return (
        <ErrorWithStyled { ...props }>
            { props.children }
        </ErrorWithStyled>
    )
}

const ErrorWithStyled = styled.span`
    color: #dc3545;
    display: inline-block;
    margin-top: 5px;
`
export default ErrorText;